export function CookieSettingsSetup() {
    let settingsButton = document.getElementById('CookieSettings');
    if(settingsButton != null) {
        settingsButton.addEventListener('click', function (e) {
            e.preventDefault();
            OneTrust.ToggleInfoDisplay();
        });
    }
}